module.exports = __webpack_public_path__ + "static/img/8.580f405.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/8.png
// module id = fOnt
// module chunks = 0